<template>
  <div>
    <div class="page-head">
      <div>
        <h2>定制需求</h2>
        <p>从需求处理到方案报价、发起支付，在此完成。</p>
      </div>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="客户编号/姓名/来源/联系人/想去地点" clearable /></el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="待处理" value="pending" />
            <el-option label="已分配" value="assigned" />
            <el-option label="规划中" value="planning" />
            <el-option label="已完成" value="completed" />
            <el-option label="已取消" value="cancelled" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="customer_no" label="客户编号" width="205" />
        <el-table-column prop="name" label="需求名称" min-width="180" />
        <el-table-column label="来源" min-width="220"><template slot-scope="{ row }">{{ sourceText(row) }}</template></el-table-column>
        <el-table-column label="来源套餐" min-width="180"><template slot-scope="{ row }">{{ packageText(row) }}</template></el-table-column>
        <el-table-column label="出行日期" width="130"><template slot-scope="{ row }">{{ row.travel_date | date }}</template></el-table-column>
        <el-table-column label="人数" width="120"><template slot-scope="{ row }">{{ peopleText(row) }}</template></el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="110" />
        <el-table-column prop="contact_phone" label="联系电话" width="130" />
        <el-table-column prop="must_visit" label="想去地点" min-width="220" show-overflow-tooltip />
        <el-table-column label="服务偏好" min-width="200" show-overflow-tooltip><template slot-scope="{ row }">{{ formatNeeds(row.needs_json) }}</template></el-table-column>
        <el-table-column prop="status" label="处理状态" width="110"><template slot-scope="{ row }"><status-tag :value="row.status" /></template></el-table-column>
        <el-table-column prop="order_no" label="关联订单" width="195"><template slot-scope="{ row }">{{ row.order_no || "尚未创建" }}</template></el-table-column>
        <el-table-column label="方案 / 收款" width="140"><template slot-scope="{ row }">{{ orderProgress(row) }}</template></el-table-column>
        <el-table-column label="应付金额" width="120"><template slot-scope="{ row }">{{ row.order_id ? `¥${Number(row.receivable_amount || 0).toFixed(2)}` : "-" }}</template></el-table-column>
        <el-table-column label="操作" width="120" fixed="right"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">处理</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog title="处理定制需求" :visible.sync="drawerVisible" width="90%" top="4vh" destroy-on-close :close-on-click-modal="false">
      <div class="demand-editor-tabs">
        <el-button type="text" :class="{ 'is-active': activeTab === 'demand' }" @click="activeTab = 'demand'">需求与联系信息</el-button>
        <el-button type="text" :class="{ 'is-active': activeTab === 'order' }" @click="activeTab = 'order'">方案、行程与支付</el-button>
      </div>
      <div v-show="activeTab === 'demand'">
          <el-form class="drawer-form" :model="form" label-width="120px">
            <el-form-item label="客户编号"><el-input v-model="form.customer_no" disabled /></el-form-item>
            <el-form-item label="需求名称"><el-input v-model="form.name" disabled /></el-form-item>
            <el-form-item label="来源"><el-input :value="sourceText(form)" disabled /></el-form-item>
            <el-form-item label="来源标题"><el-input v-model="form.source_title" disabled /></el-form-item>
            <el-form-item label="来源对象"><el-input :value="sourceObjectText(form)" disabled /></el-form-item>
            <el-form-item label="来源套餐"><el-input :value="packageText(form)" disabled /></el-form-item>
            <el-form-item label="出行日期"><el-input :value="$formatDate(form.travel_date)" disabled /></el-form-item>
            <el-form-item label="人数"><el-input :value="peopleText(form)" disabled /></el-form-item>
            <el-form-item label="联系人"><el-input v-model="form.contact_name" /></el-form-item>
            <el-form-item label="联系电话"><el-input v-model="form.contact_phone" /></el-form-item>
            <el-form-item label="想去地点"><el-input v-model="form.must_visit" type="textarea" :rows="3" /></el-form-item>
            <el-form-item label="酒店偏好"><el-input v-model="form.hotel_level" /></el-form-item>
            <el-form-item label="服务偏好"><el-input :value="formatNeeds(form.needs_json)" disabled /></el-form-item>
            <el-form-item label="处理状态">
              <el-select v-model="form.status">
                <el-option label="待处理" value="pending" />
                <el-option label="已分配" value="assigned" />
                <el-option label="规划中" value="planning" />
                <el-option label="已完成" value="completed" />
                <el-option label="已取消" value="cancelled" />
              </el-select>
            </el-form-item>
            <el-form-item label="负责员工">
              <el-select v-model="form.assigned_admin_id" clearable filterable placeholder="请选择在职员工">
                <el-option v-for="item in staffOptions" :key="item.id" :label="staffText(item)" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="补充备注"><el-input v-model="form.extra_note" type="textarea" :rows="5" /></el-form-item>
          </el-form>
          <div class="drawer-footer">
            <el-button @click="drawerVisible = false">关闭</el-button>
            <el-button type="primary" :loading="saving" @click="save">保存需求信息</el-button>
            <el-button type="success" @click="activeTab = 'order'">完善方案与支付</el-button>
          </div>
      </div>
      <div v-show="activeTab === 'order'">
          <div v-loading="orderLoading">
            <el-alert v-if="!orderReady" type="info" :closable="false" title="首次录入会保存需求并建立方案草稿；随后可在此填写全部信息、保存草稿或发起支付。草稿不会展示为客户待支付订单。" />
            <el-button v-if="!orderReady" type="primary" :loading="orderLoading" :disabled="['cancelled', 'completed'].includes(form.status)" @click="createProposalOrder" style="margin-top: 16px">开始录入方案</el-button>
            <service-orders-manage v-if="orderReady" :key="form.id" ref="orderEditor" embedded :before-save="saveDemand" @saved="orderSaved" @close="drawerVisible = false" />
          </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import StatusTag from "../components/StatusTag.vue";
import { listResource, updateResource } from "../api/resources";
import http from "../api/http";
import ServiceOrdersManage from "./ServiceOrdersManage.vue";

export default {
  name: "CustomDemandsManage",
  components: { PagedTable, StatusTag, ServiceOrdersManage },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      activeTab: "demand",
      orderReady: false,
      orderLoading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", status: "" },
      form: {},
      staffOptions: []
    };
  },
  mounted() {
    this.fetchList();
    this.fetchAssignees();
  },
  methods: {
    orderProgress(row) {
      if (!row.order_id) return "未录入方案";
      if (row.order_status === "cancelled") return "订单已取消";
      if (row.payment_status === "paid") return "已支付";
      if (row.payment_status === "refunded") return "已退款";
      return row.proposal_status === "published" ? "已发布 / 待支付" : "方案草稿";
    },
    async loadOrder(order) {
      this.orderReady = true;
      await this.$nextTick();
      try { await this.$refs.orderEditor.openEdit(order); }
      catch (error) { this.orderReady = false; throw error; }
    },
    async createProposalOrder() {
      if (this.orderLoading) return;
      this.orderLoading = true;
      try {
        await this.saveDemand();
        const res = await http.post(`/custom-demands/${this.form.id}/order`);
        await this.loadOrder(res.data);
        await this.fetchList();
      } finally {
        this.orderLoading = false;
      }
    },
    async orderSaved() {
      await this.fetchList();
    },
    async saveDemand() {
      await updateResource("custom-demands", this.form.id, {
        ...this.form,
        travel_date: this.$formatDate(this.form.travel_date, "")
      });
    },
    arrayNeeds(value) {
      if (Array.isArray(value)) return value;
      try { const parsed = JSON.parse(value || "[]"); return Array.isArray(parsed) ? parsed : []; } catch (error) { return []; }
    },
    async fetchAssignees() {
      const res = await http.get("/custom-demands/assignees");
      this.staffOptions = res.data || [];
    },
    staffText(item) {
      return `${item.name || item.username}${item.staff_code ? `（${item.staff_code}）` : ""}`;
    },
    formatNeeds(value) {
      if (!value) return "-";
      if (Array.isArray(value)) return value.length ? value.join("、") : "-";
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) && parsed.length ? parsed.join("、") : "-";
      } catch (error) {
        return "-";
      }
    },
    peopleText(row) {
      const adult = Number(row.adult_count || 0);
      const child = Number(row.child_count || 0);
      const elder = Number(row.elder_count || 0);
      return `${adult}成人 / ${child}儿童 / ${elder}老人`;
    },
    sourceText(row) {
      if (!row) return "-";
      const map = {
        custom_demand_form: "高端定制",
        route_plan: "方案模板",
        route: "线路",
        mini_program: "小程序"
      };
      const base = map[row.source] || row.source || "-";
      return row.source_title ? `${base}：${row.source_title}` : base;
    },
    sourceObjectText(row) {
      if (!row) return "-";
      if (row.source === "route" && row.source_route_id) return `线路 ID：${row.source_route_id}`;
      if (row.source === "route_plan" && row.source_plan_id) return `方案模板 ID：${row.source_plan_id}`;
      return "无关联线路/方案";
    },
    packageText(row) {
      if (!row || !row.source_package_id) return "未选择套餐";
      const price = row.source_package_price === null || row.source_package_price === undefined
        ? ""
        : ` / ¥${Number(row.source_package_price).toFixed(2)}`;
      return `${row.source_package_name || "套餐"}（ID ${row.source_package_id}${price}）`;
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("custom-demands", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    async openEdit(row) {
      if (this.orderLoading) return;
      this.form = { ...row, assigned_admin_id: row.assigned_admin_id ? Number(row.assigned_admin_id) : null };
      this.orderReady = false;
      this.activeTab = "demand";
      this.drawerVisible = true;
      if (row.order_id) {
        this.orderLoading = true;
        try {
          await this.loadOrder({ id: row.order_id });
          this.activeTab = "order";
        } finally { this.orderLoading = false; }
      }
    },
    async save() {
      this.saving = true;
      try {
        await this.saveDemand();
        this.$message.success("定制需求处理结果已保存");
        this.fetchList();
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.demand-editor-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 2px solid #e4e7ed;
  margin-bottom: 24px;
}

.demand-editor-tabs .el-button {
  margin: 0;
  padding: 0 0 14px;
  border-radius: 0;
  color: #606266;
}

.demand-editor-tabs .el-button.is-active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
  margin-bottom: -2px;
}
</style>
